import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e9035542"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bbs-list" }
const _hoisted_2 = { class: "bbs-search" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 更多")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 更多")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 更多")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("近3个月活跃商家排行榜")
const _hoisted_7 = { class: "bbs-list-rank-rt" }
const _hoisted_8 = { class: "bbs-list-rank-rt-imgs" }
const _hoisted_9 = { class: "bbs-list-rank-rt-imgs-item-img" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bbs-list-rank-rt-imgs-item-img-status status4" }, null, -1))
const _hoisted_11 = { class: "bbs-list-rank-rt-imgs-item-img-label" }
const _hoisted_12 = { class: "bbs-list-line" }
const _hoisted_13 = {
  class: "infinite-list",
  style: {"overflow":"hidden"}
}
const _hoisted_14 = { class: "bbs-list-item-lt" }
const _hoisted_15 = { class: "bbs-list-item-lt-label" }
const _hoisted_16 = { class: "bbs-list-item-rt" }
const _hoisted_17 = { class: "bbs-list-item-title" }
const _hoisted_18 = { class: "bbs-list-item-title2" }
const _hoisted_19 = { class: "bbs-list-item-time" }
const _hoisted_20 = { class: "bbs-list-item-address" }
const _hoisted_21 = { style: {"color":"#409eff"} }
const _hoisted_22 = { class: "bbs-list-item-logo" }
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "bbs-list-item-logo-rt" }
const _hoisted_25 = { class: "bbs-list-item-logo-title" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" 关注商家 ")
const _hoisted_27 = { class: "bbs-list-item-des" }
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = { class: "load-more" }

import { defineComponent } from "vue";
import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive } from "vue";
import tool from "@/utils/tool";
import router from "@/router/index";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";
import { Plus, ZoomIn, Download, Delete } from '@element-plus/icons-vue';
import type { UploadFile } from 'element-plus/es/components/upload/src/upload.type';
import { useRouter } from 'vue-router'
import Bottom from '../components/bottom.vue'
import { ArrowDownBold } from '@element-plus/icons-vue'
interface ActivityBrand {
  id: string;
  name: string;
}

interface DeveloperName {
  id: string;
  name: string;
}

interface ActivityTag {
  id: string;
  name: string;
  type: number;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const activeNames = ref(["1"]);
const handleChange = (val: string[]) => {
  console.log(val);
};

const ustore = useStore();
const loading = ref(true);
const searchItemSize = ref(10);

const statusType = ref(['', 'status1', 'status2', 'status3', 'status4'])

var tagId = router.currentRoute.value.query.tagId;
if(tagId=="" || tagId==null) {
  tagId = "全部";
}

const allActivityBrand: ActivityBrand = {
  id: "all",
  name: "全部",
}
const allDeveloperName: DeveloperName = {
  id: "all",
  name: "全部",
}
const allActivityTag: ActivityTag = {
  id: "all",
  name: "全部",
  type: 7
}

const handleToDetail = (item: any) => {
  router.push('/frontDesk/bbsList/bbsDetail/' + item.id)
}

const activityBrandList: ActivityBrand[] = [];
const developerNameList: DeveloperName[] = [];
const activityTagList: ActivityTag[] = [];

const activityBrandSearch = ref(['全部'])
const developerNameSearch = ref(['全部'])
const activityTagSearch = ref(['全部'])

const bindData = reactive({
  calssType: ["", "", "", "status3", "status4", "status5", "status6"],
  type: ["", "", "", "即将开始", "报名中", "进行中", "已结束"],
  activityBrandMax: 10,
  developerNameMax: 10,
  activityTagMax: 10,
  activityBrandList: activityBrandList,
  developerNameList: developerNameList,
  activityTagList: activityTagList,
  activityBrandTotalCount: 0,
  developerNameTotalCount: 0,
  activityTagTotalCount: 0,
  activeMerchantList:[],
  activeMerchantListTotalCount: 0,
  newsPageParams: {
    curPage: 1,
    pageSize: 5,
    filtrate: {
      type: 2,
      activityTagIds: "",
      developerNames: "",
      brandNames: "",
      keyword: "",
    },
  },
  newsPageResult: {
    status: 2000,
    msg: "成功",
    result: [],
    totalCount: 0,
  },
  isLogin: ustore.state.loginMember == undefined ? false : true,
});

if (ustore.state.loginMember == undefined) {
  store.dispatch("getMyInfo").then(
    (data) => {
      //成功
      bindData.isLogin = ustore.state.loginMember == undefined ? false : true
    },
    (error) => {
      console.log("获取当前登录会员信息错误");
    }
  );
}

let defaultImage = require("@/assets/no_pict.png");

const developerNameMoreEvent = () => {
  bindData.developerNameMax = bindData.developerNameMax < bindData.developerNameTotalCount + 1 ? (bindData.developerNameMax + searchItemSize.value) : bindData.developerNameMax
  if (bindData.developerNameMax > bindData.developerNameTotalCount + 1) {
    bindData.developerNameMax = bindData.developerNameTotalCount + 1;
  }
}

const activityBrandMoreEvent = () => {
  bindData.activityBrandMax = bindData.activityBrandMax < bindData.activityBrandTotalCount + 1 ? (bindData.activityBrandMax + searchItemSize.value) : bindData.activityBrandMax
  if (bindData.activityBrandMax > bindData.activityBrandTotalCount + 1) {
    bindData.activityBrandMax = bindData.activityBrandTotalCount + 1;
  }
}

const activityTagMoreEvent = () => {
  bindData.activityTagMax = bindData.activityTagMax < bindData.activityTagTotalCount + 1 ? (bindData.activityTagMax + searchItemSize.value) : bindData.activityTagMax
  if (bindData.activityTagMax > bindData.activityTagTotalCount + 1) {
    bindData.activityTagMax = bindData.activityTagTotalCount + 1;
  }
}

store.dispatch("frontBbsModule/listActivityBrand", { type: 2 }).then(
  (data) => {
    //成功
    bindData.activityBrandMax = data.totalCount < searchItemSize.value ? (data.totalCount + 1) : searchItemSize.value
    bindData.activityBrandList = data.result;
    bindData.activityBrandTotalCount = data.totalCount;
    bindData.activityBrandList.unshift(allActivityBrand);
  },
  (error) => {
    console.log(error.msg);
  }
);

store.dispatch("frontBbsModule/listDeveloperName", { type: 2 }).then(
  (data) => {
    //成功
    bindData.developerNameMax = data.totalCount < searchItemSize.value ? (data.totalCount + 1) : searchItemSize.value
    bindData.developerNameList = data.result;
    bindData.developerNameTotalCount = data.totalCount;
    bindData.developerNameList.unshift(allDeveloperName);
  },
  (error) => {
    console.log(error.msg);
  }
);

store.dispatch("frontBbsModule/listActivityTag", { type: 2 }).then(
  (data) => {
    //成功
    bindData.activityTagMax = data.totalCount < searchItemSize.value ? (data.totalCount + 1) : searchItemSize.value
    bindData.activityTagList = data.result;
    bindData.activityTagTotalCount = data.totalCount;
    bindData.activityTagList.unshift(allActivityTag);
    const tags = bindData.activityTagList.filter(tag => tag.id==tagId)
    if(tags.length>0) {
      activityTagSearch.value= [tags[0].name];
    }
    searchEvent(false);
  },
  (error) => {
    console.log(error.msg);
  }
);

store.dispatch("frontBbsModule/listCompany", { type: 2 }).then(
  (data) => {
    //成功
    bindData.activeMerchantList = data.result;
    bindData.activeMerchantListTotalCount = data.totalCount;
  },
  (error) => {
    console.log(error.msg);
  }
);

const remainCount = ref(0)

const searchEvent = (isAppend: boolean) => {
  loading.value = true;
  const developerNameArray = developerNameSearch.value.filter(tag => tag !== "全部");
  const activityBrandArray = activityBrandSearch.value.filter(tag => tag !== "全部");
  const activityTagArray = activityTagSearch.value.filter(tag => tag !== "全部");
  bindData.newsPageParams.filtrate.developerNames = developerNameArray.join(',');
  bindData.newsPageParams.filtrate.brandNames = activityBrandArray.join(',');
  bindData.newsPageParams.filtrate.activityTagIds = bindData.activityTagList.filter(tag => activityTagArray.includes(tag.name)).map(tag => tag.id).join(",");
  store
    .dispatch(
      "frontBbsModule/pageActivityList",
      bindData.newsPageParams
    )
    .then(
      (data) => {
        //成功
        if (isAppend) {
          data.result = bindData.newsPageResult.result.concat(data.result);
        }
        bindData.newsPageResult = data;
        remainCount.value = data.totalCount - bindData.newsPageResult.result.length;
        loading.value = false;
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

const reloadSearchEvent = () => {
  bindData.newsPageParams.curPage = 1;
  bindData.newsPageParams.pageSize = 5;
  if (bindData.newsPageParams.filtrate.developerNames.length == 0) {
    if (developerNameSearch.value.length > 1) {
      developerNameSearch.value = developerNameSearch.value.filter(tag => tag !== "全部");
    }
  }
  else if (developerNameSearch.value.includes("全部")) {
    developerNameSearch.value = ["全部"];
  }
  if (bindData.newsPageParams.filtrate.brandNames.length == 0) {
    if (activityBrandSearch.value.length > 1) {
      activityBrandSearch.value = activityBrandSearch.value.filter(tag => tag !== "全部");
    }
  }
  else if (activityBrandSearch.value.includes("全部")) {
    activityBrandSearch.value = ["全部"];
  }
  if (bindData.newsPageParams.filtrate.activityTagIds.length == 0) {
    if (activityTagSearch.value.length > 1) {
      activityTagSearch.value = activityTagSearch.value.filter(tag => tag !== "全部");
    }
  }
  else if (activityTagSearch.value.includes("全部")) {
    activityTagSearch.value = ["全部"];
  }
  searchEvent(false);
};

const loadPageDataEvent = () => {
  if (bindData.newsPageParams.curPage * bindData.newsPageParams.pageSize < bindData.newsPageResult.totalCount) {
    bindData.newsPageParams.curPage = bindData.newsPageParams.curPage + 1;
    searchEvent(true);
  }
};

const convertSummary = (summary: string, request: string) => {
  if(summary!=null && summary.length>0) {
    return summary;
  }
  if(request!=null && request.length>0) {
    return request.length <= 128 ? request: request.substring(0, 128) + "...";
  }
  return "";
}

const handleToRssActivity = (e: Event, companyId: string) => {
  e.stopPropagation();
  if (bindData.isLogin) {
    store
      .dispatch("frontBbsModule/saveRssActivity", {
        rssCompanyId: companyId,
      })
      .then(
        (data) => {
          console.log(data);
          //成功
          ElMessage.success('订阅成功.');
        },
        (error) => {
          console.log(error.msg);
        }
      );
  }
  else {
    ElMessageBox.alert("请先登录...", '系统消息', {
      confirmButtonText: '确定',
      callback: (action: Action) => {
        if (action == "confirm") {
          router.push('/frontDesk/login')
        }
      },
    });
  }
}


return (_ctx: any,_cache: any) => {
  const _component_el_checkbox_button = _resolveComponent("el-checkbox-button")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_office_building = _resolveComponent("office-building")!
  const _component_clock = _resolveComponent("clock")!
  const _component_location = _resolveComponent("location")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_collapse, {
          class: "fd-bbs-list-search-hd",
          modelValue: activeNames.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((activeNames).value = $event)),
          onChange: handleChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_collapse_item, {
              title: "筛选条件",
              name: "1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_container, { class: "bbs-search-box" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form, { "label-width": "100px" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "活动类型：" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_checkbox_group, {
                              modelValue: activityTagSearch.value,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activityTagSearch).value = $event)),
                              size: "large",
                              onChange: reloadSearchEvent
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).activityTagList.slice(0, _unref(bindData).activityTagMax), (item) => {
                                  return (_openBlock(), _createBlock(_component_el_checkbox_button, {
                                    key: item.id,
                                    label: item.name
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["label"]))
                                }), 128)),
                                (_unref(bindData).activityTagTotalCount + 1 > searchItemSize.value && _unref(bindData).activityTagMax < _unref(bindData).activityTagTotalCount + 1)
                                  ? (_openBlock(), _createBlock(_unref(ElButton), {
                                      key: 0,
                                      class: "bbs-search-more",
                                      type: "text",
                                      size: "large",
                                      onClick: activityTagMoreEvent
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_3,
                                        _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(ArrowDownBold))
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "开发商：" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_checkbox_group, {
                              modelValue: developerNameSearch.value,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((developerNameSearch).value = $event)),
                              size: "large",
                              onChange: reloadSearchEvent
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).developerNameList.slice(0, _unref(bindData).developerNameMax), (item) => {
                                  return (_openBlock(), _createBlock(_component_el_checkbox_button, {
                                    key: item.id,
                                    label: item.name
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["label"]))
                                }), 128)),
                                (_unref(bindData).developerNameTotalCount + 1 > searchItemSize.value && _unref(bindData).developerNameMax < _unref(bindData).developerNameTotalCount + 1)
                                  ? (_openBlock(), _createBlock(_unref(ElButton), {
                                      key: 0,
                                      class: "bbs-search-more",
                                      type: "text",
                                      size: "large",
                                      onClick: developerNameMoreEvent
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_4,
                                        _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(ArrowDownBold))
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "品牌：" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_checkbox_group, {
                              modelValue: activityBrandSearch.value,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((activityBrandSearch).value = $event)),
                              size: "large",
                              onChange: reloadSearchEvent
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).activityBrandList.slice(0, _unref(bindData).activityBrandMax), (item) => {
                                  return (_openBlock(), _createBlock(_component_el_checkbox_button, {
                                    key: item.id,
                                    label: item.name
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["label"]))
                                }), 128)),
                                (_unref(bindData).activityBrandTotalCount + 1 > searchItemSize.value && _unref(bindData).activityBrandMax < _unref(bindData).activityBrandTotalCount + 1)
                                  ? (_openBlock(), _createBlock(_unref(ElButton), {
                                      key: 0,
                                      class: "bbs-search-more",
                                      type: "text",
                                      size: "large",
                                      onClick: activityBrandMoreEvent
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_5,
                                        _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(ArrowDownBold))
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      (_unref(bindData).activeMerchantListTotalCount>0)
        ? (_openBlock(), _createBlock(_component_el_container, {
            key: 0,
            class: "bbs-list-divider"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_divider, { "content-position": "center" }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(bindData).activeMerchantListTotalCount>0)
        ? (_openBlock(), _createBlock(_component_el_container, {
            key: 1,
            class: "brand-index-rank"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).activeMerchantList, (obj, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "bbs-list-rank-rt-imgs-item",
                      key: obj.id
                    }, [
                      _createVNode(_component_el_image, {
                        src: obj.logoFullPath,
                        style: {"width":"158px","height":"70px","border":"1px solid #cccccc"},
                        fit: "scale-down"
                      }, null, 8, ["src"]),
                      _createElementVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _createElementVNode("div", _hoisted_11, _toDisplayString("" + (index+1)), 1)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("ul", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).newsPageResult.result, (item) => {
            return _withDirectives((_openBlock(), _createElementBlock("li", {
              key: item.id,
              class: "infinite-list-item"
            }, [
              _createVNode(_component_el_container, {
                class: "bbs-list-item",
                onClick: () => handleToDetail(item)
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_el_carousel, { height: "300px" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.imageList, (image) => {
                          return (_openBlock(), _createBlock(_component_el_carousel_item, {
                            key: image.id
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_image, {
                                class: "bbs-list-item-lt-banner",
                                src: image.thumbnailUrl
                              }, null, 8, ["src"]),
                              _createElementVNode("div", {
                                class: _normalizeClass(["bbs-list-item-lt-status", _unref(bindData).calssType[item.status]])
                              }, null, 2),
                              _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(bindData).type[item.status]), 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, _toDisplayString(item.projectName), 1),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_office_building)
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" " + _toDisplayString(item.name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_el_icon, { style: {"margin-right":"5px","font-size":"16px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_clock)
                        ]),
                        _: 1
                      }),
                      _createTextVNode(_toDisplayString(item.pushTime), 1)
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_el_icon, { style: {"margin-right":"4px","font-size":"18px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_location)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("span", _hoisted_21, _toDisplayString(item.province) + "，" + _toDisplayString(item.city) + "，" + _toDisplayString(item.area) + "，" + _toDisplayString(item.address), 1)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("img", {
                        style: {"width":"50px","height":"50px"},
                        src: item.companyLogo,
                        onErrorOnce: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(defaultImage) && _unref(defaultImage)(...args)))
                      }, null, 40, _hoisted_23),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, _toDisplayString(item.companyShortName), 1)
                      ]),
                      _createVNode(_component_el_container, {
                        class: "company-index-header-collect",
                        style: {"padding-left":"50px"},
                        onClick: (e) => handleToRssActivity(e, item.companyId)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_image, {
                            fit: "fill",
                            class: "company-index-header-collect-icon",
                            style: {"background-color":"rgb(64, 158, 255)"},
                            src: require('@/assets/fd/company/u1493.png')
                          }, null, 8, ["src"]),
                          _hoisted_26
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", {
                        innerHTML: convertSummary(item.summary, item.request)
                      }, null, 8, _hoisted_28)
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])), [
              [_directive_loading, loading.value]
            ])
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_29, [
          (_unref(bindData).newsPageResult.result.length < _unref(bindData).newsPageResult.totalCount)
            ? (_openBlock(), _createBlock(_unref(ElButton), {
                key: 0,
                class: "load-more-button",
                type: "text",
                size: "large",
                onClick: loadPageDataEvent
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 加载更多..." + _toDisplayString(remainCount.value), 1),
                  _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ArrowDownBold))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(Bottom)
  ]))
}
}

})